// extracted by mini-css-extract-plugin
export const selectorDiv = "photoSelector-module--selectorDiv--27UUA";
export const buttonGrid = "photoSelector-module--buttonGrid--1RH0R";
export const button = "photoSelector-module--button--2kfXh";
export const button__active = "photoSelector-module--button__active--25rMq";
export const text = "photoSelector-module--text--2hyku";
export const imgOverlay = "photoSelector-module--imgOverlay--30Vo6";